/**
 * Format date to Indonesian format: "12 Feb 2025"
 * @param {string|Date} dateStr - Date string or Date object
 * @returns {string} Formatted date string
 */
export const formatViewDate = (dateStr) => {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  
  const day = date.getDate();
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  
  return `${day} ${month} ${year}`;
};

/**
 * Format ISO datetime to YYYY-MM-DD HH:mm
 * @param {string} isoDate - ISO date string
 * @returns {string} Formatted datetime string
 */
export const formatISOToYMDHM = (isoDate) => {
  if (!isoDate) return '';
  
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};

/**
 * Format datetime to dd/mm/yyyy HH:mm
 * @param {string|Date} dateStr - Date string or Date object
 * @returns {string} Formatted datetime string
 */
export const formatDateTimeDMY = (dateStr) => {
  if (!dateStr) return '';
  
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}`;
};
